
import { SubmitPrecheckinPost } from '@precheckin/models/visit/submit-precheckin-post.model';
import { VisitRecordPost } from '@precheckin/models/visit/visit-record-post.model';
import { VisitRequest } from '@precheckin/models/visit/visit-request.model';
import { Visit } from '@precheckin/models/visit/visit.model';

export enum PreCheckinStateActionTypes {
  IsVisitReady = '[SetIsReady] action',
  GetVisit = '[GetVisit] action',
  CreateVisit = '[CreateVisit] action',
  SaveVisit = '[SaveVisit] action',
  ResetVisit = '[ResetVisit] action',
  RecordStartPreCheckin = '[RecordStartPreCheckin] action',
  SubmitVisit = '[SubmitVisit] action',
  ShowMessage = '[ShowMessage] action',
  GetQRCode = '[GetQRCode] action',
  DisplaySurvey = '[DisplaySurvey] action',
  IsNewVisit = '[SetisNewVisit] action'
}

export class IsVisitReady {
  public static readonly type = PreCheckinStateActionTypes.IsVisitReady;
  constructor(public payload: boolean) {}
}

export class GetVisit {
  public static readonly type = PreCheckinStateActionTypes.GetVisit;
  constructor(public id: string) {}
}

export class CreateVisit {
  public static readonly type = PreCheckinStateActionTypes.CreateVisit;
  constructor(public visit: VisitRequest) {}
}

export class RecordStartPreCheckin {
  public static readonly type =
    PreCheckinStateActionTypes.RecordStartPreCheckin;
  constructor(public visitRecordPost: VisitRecordPost) {}
}

export class SubmitVisit {
  public static readonly type = PreCheckinStateActionTypes.SubmitVisit;
  constructor(public submitPrecheckinPost: SubmitPrecheckinPost) {}
}

export class SaveVisit {
  public static readonly type = PreCheckinStateActionTypes.SaveVisit;
  constructor(public visit: Visit) {}
}

export class ResetVisit {
  public static readonly type = PreCheckinStateActionTypes.ResetVisit;
}

export class ShowMessage {
  public static readonly type = PreCheckinStateActionTypes.ShowMessage;
  constructor(public showMessage: boolean) {}
}

export class GetQRCode {
  public static readonly type = PreCheckinStateActionTypes.GetQRCode;
  constructor(public visitId: string) {}
}

export class DisplaySurvey {
  public static readonly type = PreCheckinStateActionTypes.DisplaySurvey;
  constructor(public displaySurvey: boolean) {}
}

export class IsNewVisit {
  public static readonly type = PreCheckinStateActionTypes.IsNewVisit;
  constructor(public payload: boolean) {}
}
